export const Facebook = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.6166 9.03045e-05H2.38361C1.06946 9.03045e-05 0.000107711 1.05934 0.000107711 2.36107V13.6391C0.000107711 14.9408 1.06946 16.0001 2.38361 16.0001H7.18241V10.4199H5.2756V7.58672H7.18241V5.66645C7.18241 4.10414 8.46541 2.83327 10.0426 2.83327H12.9346V5.66645H10.0426V7.58672H12.9346L12.4579 10.4199H10.0426V16.0001H13.6166C14.9308 16.0001 16.0001 14.9408 16.0001 13.6391V2.36107C16.0001 1.05934 14.9308 9.03045e-05 13.6166 9.03045e-05Z"
        fill="#434343"
      />
    </svg>
  );
};
